<template>
  <div class="w-100">
    <div class="tab__header">
      <div class="h3 h3--primary">Pracownicy</div>
      <div class="tab__edit"  :class="{ 'tab__edit--disabled': loading }">
				<span class="tab__manage" @click="addEmployee()" v-if="!tab.editting">
					<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17.01" viewBox="0 0 17 17.01" v-bind:svg-inline="''" v-bind:class="'tab__icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g data-name="dodaj kolejny"><g data-name="Group 2128"><g data-name="Group 2127" fill="none" stroke="#e95e0c" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2"><path data-name="Line 8" d="M8.505 1v15.01"/><path data-name="Line 9" d="M1 8.505h15"/></g></g></g></svg>
					Dodaj kolejny
				</span>
        <span v-if="tab.editting" @click="tab.editting = false" class="tab__manage">Anuluj</span>
        <span v-if="tab.editting" @click="saveData(tab)" class="tab__manage">Zapisz</span>
        <span v-else @click="tab.editting = true" class="tab__manage">
					<svg xmlns="http://www.w3.org/2000/svg" width="19.2" height="19.299" viewBox="0 0 19.2 19.299" v-bind:svg-inline="''" v-bind:class="'tab__icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g data-name="Group 2128"><g data-name="Group 1660"><g data-name="Group 1612"><g data-name="Group 1607"><g data-name="Group 1606"><path data-name="Path 2944" d="M1.47 12.915L13.36 1.029a1.11 1.11 0 011.568 0l3.351 3.351a1.11 1.11 0 010 1.568L6.383 17.829" fill="none" stroke="#e95e0c" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.2"/></g><path data-name="Path 2945" d="M6.383 17.828L.6 18.695l.87-5.783" fill="none" stroke="#e95e0c" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.2"/></g><path data-name="Line 10" fill="none" stroke="#e95e0c" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.2" d="M.871 16.887l1.512 1.512"/><g data-name="Group 1611"><g data-name="Group 1608"><path data-name="Path 2946" d="M15.778 1.881L3.892 13.768a1.11 1.11 0 01-1.568 0l-.072-.072a1.11 1.11 0 010-1.568L10.14 4.24" fill="none" stroke="#e95e0c" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.2"/></g><g data-name="Group 1609"><path data-name="Path 2947" d="M17.418 3.521L5.531 15.408a1.11 1.11 0 01-1.568 0l-.072-.072a1.11 1.11 0 010-1.568L15.778 1.881" fill="none" stroke="#e95e0c" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.2"/></g><g data-name="Group 1610"><path data-name="Path 2948" d="M15.051 9.161l-7.882 7.888a1.11 1.11 0 01-1.568 0l-.072-.072a1.11 1.11 0 010-1.568L17.417 3.521" fill="none" stroke="#e95e0c" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.2"/></g></g></g></g></g></svg>
					Edytuj
				</span>
      </div>
    </div>
    <div class="tab__body">
      <ValidationObserver
          class="tab__data"
          v-for="(employee, index) in employees"
          :key="index"
          :id="'employee' + index"
          ref="observer"
          tag="form"
      >
        <div class="tab__heading">
          <div class="h4">Pracownik {{ parseInt(index) + 1 }}</div>
          <div class="tab__edit">
          <span class="tab__manage" @click="deleteEmployee(index, employee)">
            Usuń
          </span>
          </div>
        </div>
        <EmployeeForm :index="index" :tab="tab" />
      </ValidationObserver>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/scss/pages/profil-panel';
@import '@/assets/scss/components/form/form';
</style>

<script>
import {panelTabsMixin} from '@/mixins/panel-tabs.js'
import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import { getterTypes } from "@/store/modules/Organization/getter-types";
import {actionTypes} from "@/store/modules/Organization/action-types";
import {mapActions, mapGetters} from "vuex";
import { ValidationObserver } from "vee-validate";
import {validateMessages} from "@/config";


Vue.use(VueScrollTo, {
  offset: -150,
})

export default {
  name: 'ManageEmployees',
  mixins: [panelTabsMixin],
  components: {
    ValidationObserver,
    EmployeeForm: () => import("@/pages/components/forms/EmployeeForm.vue"),
  },
  created() {
    this.FETCH_EMPLOYEES();
  },
  computed: {
    employees() {
      return this.GET_EMPLOYEES();
    }
  },
  data() {
    return {
      loading: false
    }
  },
  methods: {
    ...mapActions("OrganizationModule", [
        actionTypes.FETCH_EMPLOYEES,
        actionTypes.CREATE_EMPLOYEE,
        actionTypes.UPDATE_EMPLOYEE,
        actionTypes.DELETE_EMPLOYEE
    ]),
    ...mapGetters("OrganizationModule", [getterTypes.GET_EMPLOYEES]),
    async asyncForEach(array, callback) {
      for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array);
      }
    },
    async saveData() {
      this.$notify({
        group: validateMessages.group,
        type: "info",
        text: "Trwa zapisywanie danych...",
      });

      this.loading = true;
      await this.asyncForEach(this.employees, async (employee) => {
        if (employee.id) {
          await this.UPDATE_EMPLOYEE({ id: employee.id, body: employee });
        } else {
          await this.CREATE_EMPLOYEE(employee)
              .then((response) => {
                console.log(response);
              })
              .catch ((error) => {
                console.log(error);
              });
        }
      });

      await this.GET_EMPLOYEES();

      this.$notify({
        group: validateMessages.group,
        type: "success",
        title: validateMessages.success.header,
        text: "Dane zostały zapisane",
      });

      this.loading = false;
      this.tab.editting = false;
    },
    addEmployee() {
      this.tab.editting = this.employees.length;
      this.addEmptyEmployee();
      this.$nextTick(() => {
        const number = this.employees.length - 1;
        const id = "#empoloyee" + number;
        VueScrollTo.scrollTo(id);
      });
    },
    async deleteEmployee(index, employee) {
      if (employee.id) {
        this.loading = true;
        this.$notify({
          group: validateMessages.group,
          type: "info",
          text: "Trwa usuwanie adresu...",
        });

        await this.DELETE_EMPLOYEE(employee.id)
            .then((response) => {
              this.$notify({
                group: validateMessages.group,
                type: "success",
                title: validateMessages.success.header,
                text: response,
              });
            })
            .catch(() => {
              this.$notify({
                group: validateMessages.group,
                type: "error",
                title: validateMessages.error.header,
                text: "Wystąpił błąd podczas usuwania pracownika",
              });
            })
            .finally(() => {
              this.tab.editting = false;
              this.employees.splice(index, 1);
              this.loading = false;
            });
      } else {
        this.tab.editting = false;
        this.employees.splice(index, 1);
      }
    },
    addEmptyEmployee() {
      this.employees.push({
        "firstName": "",
        "lastName": "",
        "position": "",
        "phoneNumber": "",
        "email": "",
        "password": "",
      });
    },
  }
}
</script>
